/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_5_OpenaiInputs */

const en_privacy_section_5_openai = /** @type {(inputs: Privacy_Section_5_OpenaiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenAI`)
};

const lv_privacy_section_5_openai = /** @type {(inputs: Privacy_Section_5_OpenaiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenAI`)
};

/**
* | output |
* | --- |
* | "OpenAI" |
*
* @param {Privacy_Section_5_OpenaiInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_5_openai = /** @type {((inputs?: Privacy_Section_5_OpenaiInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_5_OpenaiInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_5_openai(inputs)
	return en_privacy_section_5_openai(inputs)
});